import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=9796406a&scoped=true&lang=pug"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=9796406a&prod&scoped=true&lang=css"
import style1 from "./Cadastro.vue?vue&type=style&index=1&id=9796406a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9796406a",
  null
  
)

export default component.exports